import React from 'react';
import { Sparkles, X } from 'lucide-react';

interface WeeklyInsightsBannerProps {
  onView: () => void;
  onDismiss: () => void;
}

export const WeeklyInsightsBanner: React.FC<WeeklyInsightsBannerProps> = ({ onView, onDismiss }) => (
  <div className="mx-4 mb-4 flex items-center justify-between px-4 py-3 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl text-white shadow-lg">
    <div className="flex items-center space-x-3">
      <Sparkles className="w-5 h-5 flex-shrink-0" />
      <p className="text-sm font-medium">Your Weekly Insights are ready!</p>
    </div>
    <div className="flex items-center space-x-2 flex-shrink-0 ml-4">
      <button
        onClick={onView}
        aria-label="View Insights"
        className="text-xs font-semibold bg-white/20 hover:bg-white/30 px-3 py-1.5 rounded-lg transition-colors duration-150 cursor-pointer"
      >
        View Insights
      </button>
      <button
        onClick={onDismiss}
        aria-label="Dismiss"
        className="p-1 hover:bg-white/20 rounded-lg transition-colors duration-150 cursor-pointer"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  </div>
);
